import { render, staticRenderFns } from "./data51.vue?vue&type=template&id=124aeafc&scoped=true"
import script from "./data51.vue?vue&type=script&lang=js"
export * from "./data51.vue?vue&type=script&lang=js"
import style1 from "./data51.vue?vue&type=style&index=1&id=124aeafc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124aeafc",
  null
  
)

export default component.exports